import { css } from 'lit';

export const appHeaderStyles = css`
  :host {
    display: block;
    margin-bottom: 1.75rem;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    border-bottom: 1px solid var(--border-color, #e5e5de);
    padding-bottom: 1.25rem;
  }

  .title-area {
    flex: 1;
  }

  h1 {
    font-family: var(--font-serif, serif);
    font-size: 1.95rem;
    font-weight: 700;
    color: var(--text-primary, #1a1a18);
    margin: 0 0 0.5rem 0;
    letter-spacing: -0.01em;
  }

  .meta-line {
    font-family: var(--font-mono, monospace);
    font-size: 0.78rem;
    color: var(--text-muted, #7c7c75);
    display: flex;
    gap: 0.8rem;
    flex-wrap: wrap;
  }

  .meta-link {
    color: var(--text-muted, #7c7c75);
    text-decoration: none;
    border-bottom: 1px dotted var(--text-muted, #7c7c75);
  }

  .meta-link:hover {
    color: var(--accent-color, #245590);
    border-bottom-style: solid;
  }
`;
